const COLUMN_AUTO_SIZE = 9999;

export { COLUMN_AUTO_SIZE };
//# sourceMappingURL=Table.constants.js.map
